/** @format */

import { isHttp } from '@power/utils';
import { useGlobalStoreWithOut, getFirstWordFromLocationPathname, getEnvUrlByUrl } from '@power/runtime-vue3';
import PcpMoMenu from './index.vue';
import GridMoMenu from './grid-menu.vue';
import ListMoMenu from './list-menu.vue';

export { PcpMoMenu, GridMoMenu, ListMoMenu };

export function onClickMenuItem(item) {
	const globalStore = useGlobalStoreWithOut();
	const { curSystem } = globalStore;
	const curSystemAlias = curSystem.alias;

	// const { parentId, id, name, alias, resourceType, isFolder, defaultUrl, displayInMenu, systemId, sysType, appIcon }
	const { resourceType, defaultUrl, sysType } = item;
	// return
	let url = '';
	const urlBase = getEnvUrlByUrl(``);
	const urlBaseInner = getEnvUrlByUrl(`/inner-link?targeturl=`);

	const urlBaseOuter = getEnvUrlByUrl(`/outer-link?targeturl=`);
	let webviewUrl = '';
	let link = '';
	const firstWord = getFirstWordFromLocationPathname(defaultUrl);

	if (resourceType === 'menu') {
		if ('outer' === sysType) {
			// outer
			let newPath = '';
			if (isHttp(defaultUrl)) {
				newPath = defaultUrl;
			} else {
				newPath = `${window.location.origin}${getEnvUrlByUrl(defaultUrl)}`;
			}
			link = encodeURIComponent(newPath);
			webviewUrl = `${link}`;
			url = `${urlBaseOuter}${webviewUrl}`;
		} else if ('inner' === sysType) {
			// inner
			link = encodeURIComponent(getEnvUrlByUrl(defaultUrl));
			webviewUrl = `${link}`;
			url = `${urlBaseInner}${webviewUrl}`;
		} else if ('self' === sysType) {
			// self
			if (curSystemAlias === firstWord) {
				link = defaultUrl.substring(curSystemAlias.length + 1);
				webviewUrl = `${link}`;
				url = `${urlBase}${webviewUrl}`;
			} else {
				link = defaultUrl;
				webviewUrl = `${link}`;
				url = `${urlBase}${webviewUrl}`;
			}
		}
	} else {
		// 不会到这里；
		return;
	}

	// console.log('url', url);
	// location.href = url;
	return url;
}
